
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"d":"M32 17.321c-.135.759-.25 1.519-.423 2.259a15.971 15.971 0 11.327-5.268 2.561 2.561 0 00.1.365z","fill":"#3a3a3a"}}),_c('path',{staticClass:"b",attrs:{"d":"M25.632 20.431a2.894 2.894 0 01-.388 1.037 2.191 2.191 0 01-1.73 1.019c-.739.036-1.478.009-2.226.009v-1.533h2.01a.772.772 0 00.793-.793v-6.41c0-.036-.009-.072-.009-.117H7.417v6.446a.788.788 0 00.883.874h1.956V22.5h-.91c-.478-.009-.964.018-1.442-.027a2.29 2.29 0 01-2.028-2.3c-.009-2.1 0-4.21 0-6.31 0-1.136.018-2.281-.009-3.417a2.348 2.348 0 011.965-2.425.077.077 0 00.045-.027h15.754a.664.664 0 00.126.036 2.3 2.3 0 011.757 1.551c.054.144.081.307.126.46q-.013 5.198-.008 10.39zm-1.55-9.123v-.856a.8.8 0 00-.91-.91H8.192a.728.728 0 00-.766.649c-.036.37-.009.739-.009 1.118z"}}),_c('path',{staticClass:"b",attrs:{"d":"M16.557 24.794c.685-.685 1.361-1.379 2.037-2.055.37.37.73.73 1.081 1.073l-3.92 3.921c-1.307-1.307-2.623-2.614-3.929-3.921.342-.343.7-.694 1.063-1.055.667.667 1.343 1.352 2.028 2.028.018-.009.027-.018.045-.027v-6.2h1.541v6.22a.1.1 0 01.054.016zM18.674 14.806v1.514H8.499v-1.514z"}})])
          )
        }
      }
    